module.exports = __webpack_public_path__ + "static/media/Carrefour.41507a7a.svg";